import { InfoCircleFilled } from '@ant-design/icons'
import Tooltip from 'components/UI/Tooltip'

interface InformationTooltipProps {
  messages: string[]
  color?: string
  intro?: string
}
function InformationTooltip({ messages, color = 'text-primary-600!', intro }: InformationTooltipProps) {
  return (
    <Tooltip
      placement="right"
      title={
        <div className="flex w-full flex-wrap">
          <ul className="w-full list-none px-2">
            {intro ? (
              <>
                <li>{intro}</li>
                {messages.map(message => (
                  <li key={message}>- {message}</li>
                ))}
              </>
            ) : (
              messages.map(message => (
                <li key={message}>{message}</li>
              ))
            )}
          </ul>
        </div>
      }
    >
      <span className="ml-4">
        <InfoCircleFilled className={color} />
      </span>
    </Tooltip>
  )
}

export default InformationTooltip
